// extracted by mini-css-extract-plugin
export var link = "_sb-0";